// @ vendors
import React, { Component } from 'react';
const { Redirect } = require('react-router-dom');
const PropTypes = require('prop-types');
// @ hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
// @ components
import NotFoundView from 'routes/notFoundView/notFoundView';

class FeatureToggingRoute extends Component {
    render() {
        const { component: WrappedComponent, notAllowedProductKey, flagBasedFeatures, redirectPath = false } = this.props;
        if (flagBasedFeatures.get(notAllowedProductKey)) {
            return <WrappedComponent {...this.props} />;
        } else if (!flagBasedFeatures.get(notAllowedProductKey) && redirectPath) {
            return <Redirect to={redirectPath} />;
        } else {
            return (
                <NotFoundView notFoundViewPrivate />
            );
        }
    }
}

FeatureToggingRoute.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    component: PropTypes.elementType.isRequired,
    notAllowedProductKey: PropTypes.string.isRequired,
    redirectPath: PropTypes.bool
}

export default withFeatureToggling(FeatureToggingRoute);
